"use strict";
import a from "./index.es349.js";
import o from "./index.es152.js";
import r from "./index.es148.js";
import p from "./index.es150.js";
import n from "./index.es158.js";
import f from "./index.es159.js";
function s(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new p(null, e);
}
function h(e) {
  return s(e), e.headers = n.from(e.headers), e.data = a.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), f.getAdapter(e.adapter || r.adapter, e)(e).then(function(t) {
    return s(e), t.data = a.call(
      e,
      e.transformResponse,
      t
    ), t.headers = n.from(t.headers), t;
  }, function(t) {
    return o(t) || (s(e), t && t.response && (t.response.data = a.call(
      e,
      e.transformResponse,
      t.response
    ), t.response.headers = n.from(t.response.headers))), Promise.reject(t);
  });
}
export {
  h as default
};
//# sourceMappingURL=index.es262.js.map
